import { useMemo } from 'react'

import { useQuery } from 'react-query'

import {
  Integration,
  type IntegrationConstructor,
} from '@webapp/platform/integrations/entities'
import { integrationQueries } from '@webapp/platform/integrations/queries/integrationQueries'

export const useQueryIntegrationsList = ({
  enabled = true,
}: {
  enabled?: boolean
}) => {
  const { data, isLoading, isError } = useQuery<IntegrationConstructor[]>({
    ...integrationQueries.list(),
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  const integrations = useMemo(() => {
    return (
      data?.map(
        (constructorData: IntegrationConstructor) =>
          new Integration(constructorData)
      ) ?? []
    )
  }, [data])

  return {
    integrations,
    isLoading,
    isError,
  }
}
